import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DataMapperExplorerStore from "./DataMapperExplorerStore";

const explorerStore = (rootStore: RootStore) =>
  rootStore.dataMapperExplorerViewStore as DataMapperExplorerStore;

/**
 * Data Mapper → Explore: the schema, column profiles, AI analysis and saved
 * reports of the source this tab connected to on the Data Source page. Gated
 * like the Profiles route (operator tier, checked by the store and enforced by
 * the API); its background jobs report through tabEvents.ts.
 */
const dataMapperExplorerRoute: RouteType[] = [
  {
    name: "Data Mapper Explore",
    path: "/data-mapper/explore",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Explore Source",
        enableRefreshButton: true,
        component: () => import("./DataMapperExplorer.Header"),
      },
      body: {
        component: () => import("./DataMapperExplorer.Body"),
        grayBackground: true,
      },
    },
    group: "Data Mapper",
    searchAliases: ["data mapper explore", "profile source", "data quality", "schema explorer", "explorer report"],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void explorerStore(rootStore)?.enter();
    },
    onExit: ({ rootStore }) => {
      explorerStore(rootStore)?.reset();
    },
  },
];

export default dataMapperExplorerRoute;
